<script setup lang="ts">
import { PanelProps } from '~/components/cms/PanelSwitcher.vue'
import type { SEOProps } from '~/helpers/seo'

type Props = {
  seo?: SEOProps
  panels?: PanelProps[]
  supportingData?: {
    home: {
      variant?: {
        value: 'standard' | 'half-width' | 'no-spacing' | ''
      }
    }
  }
}

const props = defineProps<Props>()
const variant = props.supportingData?.home?.variant?.value || ''
const route = useRoute()
const isArticle = route.path.includes('/article')

useHead(
  getHeaderData({
    seo: props?.seo,
    locale: useI18n().locale.value,
    path: route.path || '',
  }),
)

useSchemaOrg().initContentSchema({
  type: 'Article',
  headline: props.seo?.title || '',
  description: props.seo?.description,
})
</script>

<template>
  <div class="content-page" :class="`content-page--${variant}`" data-testid="content-page">
    <PanelSwitcher v-for="(panel, i) in panels" :key="i" v-bind="panel" :priority="i === 0" />
    <StickySignUpPanel v-if="isArticle" />
  </div>
</template>

<style lang="postcss">
.content-page {
  > .rich-text-panel {
    margin-bottom: var(--space-80);
  }

  &.content-page--half-width {
    > .rich-text-panel > .container {
      margin-inline: auto;
      max-width: 40rem;
    }
  }
}
</style>
